import { contracts } from './contracts';

export const pt = {
  contracts,
};
